/*!
	CSS Browser Selector
	Copyright	Rafael Lima / Richard Duchatsch Johansen / Ihor Zenich
	License		Creative Commons
	Version		0.81

	https://github.com/rafaelp/css_browser_selector
	https://github.com/ridjohansen/css_browser_selector
	https://github.com/delka/css_browser_selector
	https://github.com/verbatim/css_browser_selector
*/
!function(){var e={ua:"",is:function(t){return RegExp(t,"i").test(e.ua)},version:function(e,t){for(var i=(t=t.replace(".","_")).indexOf("_"),n="";i>0;)n+=" "+e+t.substring(0,i),i=t.indexOf("_",i+1);return n+=" "+e+t},getBrowser:function(){var t="gecko",i="webkit",n="chrome",o="firefox",r="safari",p="opera",s=e.ua,d=e.is;return[!/opera|webtv/i.test(s)&&/msie\s(\d+)/.test(s)?"ie ie"+(/trident\/4\.0/.test(s)?"8":RegExp.$1):d("edge/")?"edge ie"+(/edge\/(\d+)\.(\d+)/.test(s)?RegExp.$1+" ie"+RegExp.$1+"_"+RegExp.$2:""):d("trident/")?"ie ie"+(/trident\/.+rv:(\d+)/i.test(s)?RegExp.$1:""):d("firefox/")?t+" "+o+(/firefox\/((\d+)(\.(\d+))(\.\d+)*)/.test(s)?" "+o+RegExp.$2+" "+o+RegExp.$2+"_"+RegExp.$4:""):d("gecko/")?t:d("opera")?p+(/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(s)?" "+p+RegExp.$2+" "+p+RegExp.$2+"_"+RegExp.$4:/opera(\s|\/)(\d+)\.(\d+)/.test(s)?" "+p+RegExp.$2+" "+p+RegExp.$2+"_"+RegExp.$3:""):d("konqueror")?"konqueror":d("chrome")?i+" "+n+(/chrome\/((\d+)(\.(\d+))(\.\d+)*)/.test(s)?" "+n+RegExp.$2+(RegExp.$4>0?" "+n+RegExp.$2+"_"+RegExp.$4:""):""):d("iron")?i+" iron":d("applewebkit/")?i+" "+r+(/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(s)?" "+r+RegExp.$2+" "+r+RegExp.$2+RegExp.$3.replace(".","_"):/ Safari\/(\d+)/i.test(s)?"419"==RegExp.$1||"417"==RegExp.$1||"416"==RegExp.$1||"412"==RegExp.$1?" "+r+"2_0":"312"==RegExp.$1?" "+r+"1_3":"125"==RegExp.$1?" "+r+"1_2":"85"==RegExp.$1?" "+r+"1_0":"":""):d("mozilla/")?t:""]},getPlatform:function(){var t="winphone",i="android",n="blackberry",o=e.ua,r=e.version,p=e.is;return[p("j2me")?"j2me":p("windows phone")?t+(/Windows Phone (\d+)(\.(\d+))+/i.test(o)?" "+t+RegExp.$1+" "+t+RegExp.$1+RegExp.$2.replace(".","_"):/Windows Phone OS (\d+)(\.(\d+))+/i.test(o)?" "+t+RegExp.$1+" "+t+RegExp.$1+RegExp.$2.replace(".","_"):""):p("blackberry")?n+(/Version\/(\d+)(\.(\d+)+)/i.test(o)?" "+n+RegExp.$1+" "+n+RegExp.$1+RegExp.$2.replace(".","_"):/Blackberry ?(([0-9]+)([a-z]?))[\/|;]/gi.test(o)?" "+n+RegExp.$2+(RegExp.$3?" "+n+RegExp.$2+RegExp.$3:""):""):p("android")?i+(/Version\/(\d+)(\.(\d+))+/i.test(o)?" "+i+RegExp.$1+" "+i+RegExp.$1+RegExp.$2.replace(".","_"):"")+(/Android (.+); (.+) Build/i.test(o)?" device_"+RegExp.$2.replace(/ /g,"_").replace(/-/g,"_"):""):p("ipad|ipod|iphone")?(/CPU( iPhone)? OS (\d+[_|\.]\d+([_|\.]\d+)*)/i.test(o)?"ios"+r("ios",RegExp.$2):"")+" "+(/(ip(ad|od|hone))/gi.test(o)?RegExp.$1:""):p("playbook")?"playbook":p("kindle|silk")?"kindle":p("playbook")?"playbook":p("mac")?"mac"+(/mac os x ((\d+)[.|_](\d+))/.test(o)?" mac"+RegExp.$2+" mac"+RegExp.$1.replace(".","_"):""):p("win")?"win"+(p("windows nt 10.0")?" win10":p("windows nt 6.3")?" win8_1":p("windows nt 6.2")?" win8":p("windows nt 6.1")?" win7":p("windows nt 6.0")?" vista":p("windows nt 5.2")||p("windows nt 5.1")?" win_xp":p("windows nt 5.0")?" win_2k":p("windows nt 4.0")||p("WinNT4.0")?" win_nt":""):p("freebsd")?"freebsd":p("x11|linux")?"linux":""]},getMobile:function(){return[(0,e.is)("android|mobi|mobile|j2me|iphone|ipod|ipad|blackberry|winphone|playbook|kindle|silk")?"mobile":""]},getIpadApp:function(){var t=e.is;return[t("ipad|iphone|ipod")&&!t("safari")?"ipad_app":""]}};"undefined"==typeof html&&(html=document.documentElement),window.css_browser_selector=function(t,i){var n=document.documentElement,o=[];i=i||"",e.ua=t.toLowerCase(),o=(o=(o=(o=(o=o.concat(e.getBrowser())).concat(e.getPlatform())).concat(e.getMobile())).concat(e.getIpadApp())).concat(["js"]);var r=n.className.split(/ /);return o=o.concat(r),Array.prototype.filter||(Array.prototype.filter=function(e){"use strict";if(void 0===this||null===this)throw new TypeError;var t=Object(this),i=t.length>>>0;if("function"!=typeof e)throw new TypeError;for(var n=[],o=arguments.length>=2?arguments[1]:void 0,r=0;r<i;r++)if(r in t){var p=t[r];e.call(o,p,r,t)&&n.push(p)}return n}),(o=o.filter(function(e){return"no-js"!==e&&e}))[0]=i?i+o[0]:o[0],n.className=o.join(" "+i),n.className}}();var css_browser_selector_ns=css_browser_selector_ns||"";css_browser_selector(navigator.userAgent,css_browser_selector_ns);
/*!
	what-input
	Copyright	Jeremy Fields
	License		MIT
	Version		5.2.10

	https://github.com/ten1seven/what-input
*/
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define("whatInput",[],t):"object"==typeof exports?exports.whatInput=t():e.whatInput=t()}(this,function(){return i={},n.m=o=[function(e,t){"use strict";e.exports=function(){if("undefined"==typeof document||"undefined"==typeof window)return{ask:function(){return"initial"},element:function(){return null},ignoreKeys:function(){},specificKeys:function(){},registerOnChange:function(){},unRegisterOnChange:function(){}};var t=document.documentElement,n=null,s="initial",u=s,o=Date.now(),i="false",d=["button","input","select","textarea"],r=[],c=[16,17,18,91,93],w=[],p={keydown:"keyboard",keyup:"keyboard",mousedown:"mouse",mousemove:"mouse",MSPointerDown:"pointer",MSPointerMove:"pointer",pointerdown:"pointer",pointermove:"pointer",touchstart:"touch",touchend:"touch"},a=!1,f={x:null,y:null},l={2:"touch",3:"touch",4:"mouse"},m=!1;try{var e=Object.defineProperty({},"passive",{get:function(){m=!0}});window.addEventListener("test",null,e)}catch(e){}var h=function(){var e=!!m&&{passive:!0};document.addEventListener("DOMContentLoaded",v),window.PointerEvent?(window.addEventListener("pointerdown",y),window.addEventListener("pointermove",E)):window.MSPointerEvent?(window.addEventListener("MSPointerDown",y),window.addEventListener("MSPointerMove",E)):(window.addEventListener("mousedown",y),window.addEventListener("mousemove",E),"ontouchstart"in window&&(window.addEventListener("touchstart",y,e),window.addEventListener("touchend",y))),window.addEventListener(O(),E,e),window.addEventListener("keydown",y),window.addEventListener("keyup",y),window.addEventListener("focusin",L),window.addEventListener("focusout",b)},v=function(){if(i=!(t.getAttribute("data-whatpersist")||"false"===document.body.getAttribute("data-whatpersist")))try{window.sessionStorage.getItem("what-input")&&(s=window.sessionStorage.getItem("what-input")),window.sessionStorage.getItem("what-intent")&&(u=window.sessionStorage.getItem("what-intent"))}catch(e){}g("input"),g("intent")},y=function(e){var t=e.which,n=p[e.type];"pointer"===n&&(n=S(e));var o=!w.length&&-1===c.indexOf(t),i=w.length&&-1!==w.indexOf(t),r="keyboard"===n&&t&&(o||i)||"mouse"===n||"touch"===n;if(M(n)&&(r=!1),r&&s!==n&&(x("input",s=n),g("input")),r&&u!==n){var a=document.activeElement;a&&a.nodeName&&(-1===d.indexOf(a.nodeName.toLowerCase())||"button"===a.nodeName.toLowerCase()&&!C(a,"form"))&&(x("intent",u=n),g("intent"))}},g=function(e){t.setAttribute("data-what"+e,"input"===e?s:u),k(e)},E=function(e){var t=p[e.type];"pointer"===t&&(t=S(e)),A(e),(!a&&!M(t)||a&&"wheel"===e.type||"mousewheel"===e.type||"DOMMouseScroll"===e.type)&&u!==t&&(x("intent",u=t),g("intent"))},L=function(e){e.target.nodeName?(n=e.target.nodeName.toLowerCase(),t.setAttribute("data-whatelement",n),e.target.classList&&e.target.classList.length&&t.setAttribute("data-whatclasses",e.target.classList.toString().replace(" ",","))):b()},b=function(){n=null,t.removeAttribute("data-whatelement"),t.removeAttribute("data-whatclasses")},x=function(e,t){if(i)try{window.sessionStorage.setItem("what-"+e,t)}catch(e){}},S=function(e){return"number"==typeof e.pointerType?l[e.pointerType]:"pen"===e.pointerType?"touch":e.pointerType},M=function(e){var t=Date.now(),n="mouse"===e&&"touch"===s&&t-o<200;return o=t,n},O=function(){return"onwheel"in document.createElement("div")?"wheel":void 0!==document.onmousewheel?"mousewheel":"DOMMouseScroll"},k=function(e){for(var t=0,n=r.length;t<n;t++)r[t].type===e&&r[t].fn.call(void 0,"input"===e?s:u)},A=function(e){f.x!==e.screenX||f.y!==e.screenY?(a=!1,f.x=e.screenX,f.y=e.screenY):a=!0},C=function(e,t){var n=window.Element.prototype;if(n.matches||(n.matches=n.msMatchesSelector||n.webkitMatchesSelector),n.closest)return e.closest(t);do{if(e.matches(t))return e;e=e.parentElement||e.parentNode}while(null!==e&&1===e.nodeType);return null};return"addEventListener"in window&&Array.prototype.indexOf&&(p[O()]="mouse",h()),{ask:function(e){return"intent"===e?u:s},element:function(){return n},ignoreKeys:function(e){c=e},specificKeys:function(e){w=e},registerOnChange:function(e,t){r.push({fn:e,type:t||"input"})},unRegisterOnChange:function(e){var t=function(e){for(var t=0,n=r.length;t<n;t++)if(r[t].fn===e)return t}(e);!t&&0!==t||r.splice(t,1)},clearStorage:function(){window.sessionStorage.clear()}}}()}],n.c=i,n.p="",n(0);function n(e){if(i[e])return i[e].exports;var t=i[e]={exports:{},id:e,loaded:!1};return o[e].call(t.exports,t,t.exports,n),t.loaded=!0,t.exports}var o,i});
/*!
	enquire.js
	Copyright	Nick Williams
	License		MIT
	Version		2.1.6

	https://github.com/WickyNilliams/enquire.js
*/
!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.enquire=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){this.query=a,this.isUnconditional=b,this.handlers=[],this.mql=window.matchMedia(a);var c=this;this.listener=function(a){c.mql=a.currentTarget||a,c.assess()},this.mql.addListener(this.listener)}var e=a(3),f=a(4).each;d.prototype={constuctor:d,addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var b=this.handlers;f(b,function(c,d){if(c.equals(a))return c.destroy(),!b.splice(d,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){f(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";f(this.handlers,function(b){b[a]()})}},b.exports=d},{3:3,4:4}],2:[function(a,b,c){function d(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}var e=a(1),f=a(4),g=f.each,h=f.isFunction,i=f.isArray;d.prototype={constructor:d,register:function(a,b,c){var d=this.queries,f=c&&this.browserIsIncapable;return d[a]||(d[a]=new e(a,f)),h(b)&&(b={match:b}),i(b)||(b=[b]),g(b,function(b){h(b)&&(b={match:b}),d[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},b.exports=d},{1:1,4:4}],3:[function(a,b,c){function d(a){this.options=a,!a.deferSetup&&this.setup()}d.prototype={constructor:d,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},b.exports=d},{}],4:[function(a,b,c){function d(a,b){var c=0,d=a.length;for(c;c<d&&b(a[c],c)!==!1;c++);}function e(a){return"[object Array]"===Object.prototype.toString.apply(a)}function f(a){return"function"==typeof a}b.exports={isFunction:f,isArray:e,each:d}},{}],5:[function(a,b,c){var d=a(2);b.exports=new d},{2:2}]},{},[5])(5)});
/*!
	Responsive Accessibility
	Copyright	Paul Wisniowski
	License		MIT

	https://psdhtml.me
*/
var ariaRemove=function(els){els.forEach(function(d){d.removeAttribute('aria-hidden');d.removeAttribute('focusable');d.removeAttribute('tabindex');Array.from(d.querySelectorAll('a, input')).forEach(function(el){el.removeAttribute('tabindex')})})};var ariaAdd=function(els){els.forEach(function(d){d.setAttribute('tabindex',-1);d.setAttribute('aria-hidden',true);d.setAttribute('focusable',false);Array.from(d.querySelectorAll('a, input')).forEach(function(el){el.setAttribute('tabindex',-1)})})};
/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
(function($) {
    $.isScrollToFixed = function(el) {
        return !!$(el).data('ScrollToFixed');
    };

    $.ScrollToFixed = function(el, options) {
        // To avoid scope issues, use 'base' instead of 'this' to reference this
        // class from internal events and functions.
        var base = this;

        // Access to jQuery and DOM versions of element.
        base.$el = $(el);
        base.el = el;

        // Add a reverse reference to the DOM object.
        base.$el.data('ScrollToFixed', base);

        // A flag so we know if the scroll has been reset.
        var isReset = false;

        // The element that was given to us to fix if scrolled above the top of
        // the page.
        var target = base.$el;

        var position;
        var originalPosition;
        var originalFloat;
        var originalOffsetTop;
        var originalZIndex;

        // The offset top of the element when resetScroll was called. This is
        // used to determine if we have scrolled past the top of the element.
        var offsetTop = 0;

        // The offset left of the element when resetScroll was called. This is
        // used to move the element left or right relative to the horizontal
        // scroll.
        var offsetLeft = 0;
        var originalOffsetLeft = -1;

        // This last offset used to move the element horizontally. This is used
        // to determine if we need to move the element because we would not want
        // to do that for no reason.
        var lastOffsetLeft = -1;

        // This is the element used to fill the void left by the target element
        // when it goes fixed; otherwise, everything below it moves up the page.
        var spacer = null;

        var spacerClass;

        var className;

        // Capture the original offsets for the target element. This needs to be
        // called whenever the page size changes or when the page is first
        // scrolled. For some reason, calling this before the page is first
        // scrolled causes the element to become fixed too late.
        function resetScroll() {
            // Set the element to it original positioning.
            target.trigger('preUnfixed.ScrollToFixed');
            setUnfixed();
            target.trigger('unfixed.ScrollToFixed');

            // Reset the last offset used to determine if the page has moved
            // horizontally.
            lastOffsetLeft = -1;

            // Capture the offset top of the target element.
            offsetTop = target.offset().top;

            // Capture the offset left of the target element.
            offsetLeft = target.offset().left;

            // If the offsets option is on, alter the left offset.
            if (base.options.offsets) {
                offsetLeft += (target.offset().left - target.position().left);
            }

            if (originalOffsetLeft == -1) {
                originalOffsetLeft = offsetLeft;
            }

            position = target.css('position');

            // Set that this has been called at least once.
            isReset = true;

            if (base.options.bottom != -1) {
                target.trigger('preFixed.ScrollToFixed');
                setFixed();
                target.trigger('fixed.ScrollToFixed');
            }
        }

        function getLimit() {
            var limit = base.options.limit;
            if (!limit) return 0;

            if (typeof(limit) === 'function') {
                return limit.apply(target);
            }
            return limit;
        }

        // Returns whether the target element is fixed or not.
        function isFixed() {
            return position === 'fixed';
        }

        // Returns whether the target element is absolute or not.
        function isAbsolute() {
            return position === 'absolute';
        }

        function isUnfixed() {
            return !(isFixed() || isAbsolute());
        }

        // Sets the target element to fixed. Also, sets the spacer to fill the
        // void left by the target element.
        function setFixed() {
            // Only fix the target element and the spacer if we need to.
            if (!isFixed()) {
                //get REAL dimensions (decimal fix)
                //Ref. http://stackoverflow.com/questions/3603065/how-to-make-jquery-to-not-round-value-returned-by-width
                var dimensions = target[0].getBoundingClientRect();

                // Set the spacer to fill the height and width of the target
                // element, then display it.
                spacer.css({
                    'display' : target.css('display'),
                    'width' : dimensions.width,
                    'height' : dimensions.height,
                    'float' : target.css('float')
                });

                // Set the target element to fixed and set its width so it does
                // not fill the rest of the page horizontally. Also, set its top
                // to the margin top specified in the options.

                cssOptions={
                    'z-index' : base.options.zIndex,
                    'position' : 'fixed',
                    'top' : base.options.bottom == -1?getMarginTop():'',
                    'bottom' : base.options.bottom == -1?'':base.options.bottom,
                    'margin-left' : '0px'
                }
                if (!base.options.dontSetWidth){ cssOptions['width']=target.css('width'); };

                target.css(cssOptions);

                target.addClass(base.options.baseClassName);

                if (base.options.className) {
                    target.addClass(base.options.className);
                }

                position = 'fixed';
            }
        }

        function setAbsolute() {

            var top = getLimit();
            var left = offsetLeft;

            if (base.options.removeOffsets) {
                left = '';
                top = top - offsetTop;
            }

            cssOptions={
              'position' : 'absolute',
              'top' : top,
              'left' : left,
              'margin-left' : '0px',
              'bottom' : ''
            }
            if (!base.options.dontSetWidth){ cssOptions['width']=target.css('width'); };

            target.css(cssOptions);

            position = 'absolute';
        }

        // Sets the target element back to unfixed. Also, hides the spacer.
        function setUnfixed() {
            // Only unfix the target element and the spacer if we need to.
            if (!isUnfixed()) {
                lastOffsetLeft = -1;

                // Hide the spacer now that the target element will fill the
                // space.
                spacer.css('display', 'none');

                // Remove the style attributes that were added to the target.
                // This will reverse the target back to the its original style.
                target.css({
                    'z-index' : originalZIndex,
                    'width' : '',
                    'position' : originalPosition,
                    'left' : '',
                    'top' : originalOffsetTop,
                    'margin-left' : ''
                });

                target.removeClass('scroll-to-fixed-fixed');

                if (base.options.className) {
                    target.removeClass(base.options.className);
                }

                position = null;
            }
        }

        // Moves the target element left or right relative to the horizontal
        // scroll position.
        function setLeft(x) {
            // Only if the scroll is not what it was last time we did this.
            if (x != lastOffsetLeft) {
                // Move the target element horizontally relative to its original
                // horizontal position.
                target.css('left', offsetLeft - x);

                // Hold the last horizontal position set.
                lastOffsetLeft = x;
            }
        }

        function getMarginTop() {
            var marginTop = base.options.marginTop;
            if (!marginTop) return 0;

            if (typeof(marginTop) === 'function') {
                return marginTop.apply(target);
            }
            return marginTop;
        }

        // Checks to see if we need to do something based on new scroll position
        // of the page.
        function checkScroll() {
            if (!$.isScrollToFixed(target) || target.is(':hidden')) return;
            var wasReset = isReset;
            var wasUnfixed = isUnfixed();

            // If resetScroll has not yet been called, call it. This only
            // happens once.
            if (!isReset) {
                resetScroll();
            } else if (isUnfixed()) {
                // if the offset has changed since the last scroll,
                // we need to get it again.

                // Capture the offset top of the target element.
                offsetTop = target.offset().top;

                // Capture the offset left of the target element.
                offsetLeft = target.offset().left;
            }

            // Grab the current horizontal scroll position.
            var x = $(window).scrollLeft();

            // Grab the current vertical scroll position.
            var y = $(window).scrollTop();

            // Get the limit, if there is one.
            var limit = getLimit();

            // If the vertical scroll position, plus the optional margin, would
            // put the target element at the specified limit, set the target
            // element to absolute.
            if (base.options.minWidth && $(window).width() < base.options.minWidth) {
                if (!isUnfixed() || !wasReset) {
                    postPosition();
                    target.trigger('preUnfixed.ScrollToFixed');
                    setUnfixed();
                    target.trigger('unfixed.ScrollToFixed');
                }
            } else if (base.options.maxWidth && $(window).width() > base.options.maxWidth) {
                if (!isUnfixed() || !wasReset) {
                    postPosition();
                    target.trigger('preUnfixed.ScrollToFixed');
                    setUnfixed();
                    target.trigger('unfixed.ScrollToFixed');
                }
            } else if (base.options.bottom == -1) {
                // If the vertical scroll position, plus the optional margin, would
                // put the target element at the specified limit, set the target
                // element to absolute.
                if (limit > 0 && y >= limit - getMarginTop()) {
                    if (!wasUnfixed && (!isAbsolute() || !wasReset)) {
                        postPosition();
                        target.trigger('preAbsolute.ScrollToFixed');
                        setAbsolute();
                        target.trigger('unfixed.ScrollToFixed');
                    }
                // If the vertical scroll position, plus the optional margin, would
                // put the target element above the top of the page, set the target
                // element to fixed.
                } else if (y >= offsetTop - getMarginTop()) {
                    if (!isFixed() || !wasReset) {
                        postPosition();
                        target.trigger('preFixed.ScrollToFixed');

                        // Set the target element to fixed.
                        setFixed();

                        // Reset the last offset left because we just went fixed.
                        lastOffsetLeft = -1;

                        target.trigger('fixed.ScrollToFixed');
                    }
                    // If the page has been scrolled horizontally as well, move the
                    // target element accordingly.
                    setLeft(x);
                } else {
                    // Set the target element to unfixed, placing it where it was
                    // before.
                    if (!isUnfixed() || !wasReset) {
                        postPosition();
                        target.trigger('preUnfixed.ScrollToFixed');
                        setUnfixed();
                        target.trigger('unfixed.ScrollToFixed');
                    }
                }
            } else {
                if (limit > 0) {
                    if (y + $(window).height() - target.outerHeight(true) >= limit - (getMarginTop() || -getBottom())) {
                        if (isFixed()) {
                            postPosition();
                            target.trigger('preUnfixed.ScrollToFixed');

                            if (originalPosition === 'absolute') {
                                setAbsolute();
                            } else {
                                setUnfixed();
                            }

                            target.trigger('unfixed.ScrollToFixed');
                        }
                    } else {
                        if (!isFixed()) {
                            postPosition();
                            target.trigger('preFixed.ScrollToFixed');
                            setFixed();
                        }
                        setLeft(x);
                        target.trigger('fixed.ScrollToFixed');
                    }
                } else {
                    setLeft(x);
                }
            }
        }

        function getBottom() {
            if (!base.options.bottom) return 0;
            return base.options.bottom;
        }

        function postPosition() {
            var position = target.css('position');

            if (position == 'absolute') {
                target.trigger('postAbsolute.ScrollToFixed');
            } else if (position == 'fixed') {
                target.trigger('postFixed.ScrollToFixed');
            } else {
                target.trigger('postUnfixed.ScrollToFixed');
            }
        }

        var width = undefined;
        var windowResize = function(event) {
            if (width && width === window.innerWidth) {
                return;
            } else {
                width = window.innerWidth;
            }
            
            // Check if the element is visible before updating it's position, which
            // improves behavior with responsive designs where this element is hidden.
            if(target.is(':visible')) {
                isReset = false;
                checkScroll();
            } else {
              // Ensure the spacer is hidden
              setUnfixed();
            }
        }

        var windowScroll = function(event) {
            (!!window.requestAnimationFrame) ? requestAnimationFrame(checkScroll) : checkScroll();
        }

        // From: http://kangax.github.com/cft/#IS_POSITION_FIXED_SUPPORTED
        var isPositionFixedSupported = function() {
            var container = document.body;

            if (document.createElement && container && container.appendChild && container.removeChild) {
                var el = document.createElement('div');

                if (!el.getBoundingClientRect) return null;

                el.innerHTML = 'x';
                el.style.cssText = 'position:fixed;top:100px;';
                container.appendChild(el);

                var originalHeight = container.style.height,
                originalScrollTop = container.scrollTop;

                container.style.height = '3000px';
                container.scrollTop = 500;

                var elementTop = el.getBoundingClientRect().top;
                container.style.height = originalHeight;

                var isSupported = (elementTop === 100);
                container.removeChild(el);
                container.scrollTop = originalScrollTop;

                return isSupported;
            }

            return null;
        }

        var preventDefault = function(e) {
            e = e || window.event;
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        // Initializes this plugin. Captures the options passed in, turns this
        // off for devices that do not support fixed position, adds the spacer,
        // and binds to the window scroll and resize events.
        base.init = function() {
            // Capture the options for this plugin.
            base.options = $.extend({}, $.ScrollToFixed.defaultOptions, options);

            originalZIndex = target.css('z-index')

            // Turn off this functionality for devices that do not support it.
            // if (!(base.options && base.options.dontCheckForPositionFixedSupport)) {
            //     var fixedSupported = isPositionFixedSupported();
            //     if (!fixedSupported) return;
            // }

            // Put the target element on top of everything that could be below
            // it. This reduces flicker when the target element is transitioning
            // to fixed.
            base.$el.css('z-index', base.options.zIndex);

            // Create a spacer element to fill the void left by the target
            // element when it goes fixed.
            spacer = $('<div />');

            position = target.css('position');
            originalPosition = target.css('position');
            originalFloat = target.css('float');
            originalOffsetTop = target.css('top');

            // Place the spacer right after the target element.
            if (isUnfixed()) base.$el.after(spacer);

            // Reset the target element offsets when the window is resized, then
            // check to see if we need to fix or unfix the target element.
            $(window).bind('resize.ScrollToFixed', windowResize);

            // When the window scrolls, check to see if we need to fix or unfix
            // the target element.
            $(window).bind('scroll.ScrollToFixed', windowScroll);

            // For touch devices, call checkScroll directlly rather than
            // rAF wrapped windowScroll to animate the element
            if ('ontouchmove' in window) {
              $(window).bind('touchmove.ScrollToFixed', checkScroll);
            }

            if (base.options.preFixed) {
                target.bind('preFixed.ScrollToFixed', base.options.preFixed);
            }
            if (base.options.postFixed) {
                target.bind('postFixed.ScrollToFixed', base.options.postFixed);
            }
            if (base.options.preUnfixed) {
                target.bind('preUnfixed.ScrollToFixed', base.options.preUnfixed);
            }
            if (base.options.postUnfixed) {
                target.bind('postUnfixed.ScrollToFixed', base.options.postUnfixed);
            }
            if (base.options.preAbsolute) {
                target.bind('preAbsolute.ScrollToFixed', base.options.preAbsolute);
            }
            if (base.options.postAbsolute) {
                target.bind('postAbsolute.ScrollToFixed', base.options.postAbsolute);
            }
            if (base.options.fixed) {
                target.bind('fixed.ScrollToFixed', base.options.fixed);
            }
            if (base.options.unfixed) {
                target.bind('unfixed.ScrollToFixed', base.options.unfixed);
            }

            if (base.options.spacerClass) {
                spacer.addClass(base.options.spacerClass);
            }

            target.bind('resize.ScrollToFixed', function() {
                spacer.height(target.height());
            });

            target.bind('scroll.ScrollToFixed', function() {
                target.trigger('preUnfixed.ScrollToFixed');
                setUnfixed();
                target.trigger('unfixed.ScrollToFixed');
                checkScroll();
            });

            target.bind('detach.ScrollToFixed', function(ev) {
                preventDefault(ev);

                target.trigger('preUnfixed.ScrollToFixed');
                setUnfixed();
                target.trigger('unfixed.ScrollToFixed');

                $(window).unbind('resize.ScrollToFixed', windowResize);
                $(window).unbind('scroll.ScrollToFixed', windowScroll);

                target.unbind('.ScrollToFixed');

                //remove spacer from dom
                spacer.remove();

                base.$el.removeData('ScrollToFixed');
            });

            // Reset everything.
            windowResize();
        };

        // Initialize the plugin.
        base.init();
    };

    // Sets the option defaults.
    $.ScrollToFixed.defaultOptions = {
        marginTop : 0,
        limit : 0,
        bottom : -1,
        zIndex : 1000,
        baseClassName: 'scroll-to-fixed-fixed'
    };

    // Returns enhanced elements that will fix to the top of the page when the
    // page is scrolled.
    $.fn.scrollToFixed = function(options) {
        return this.each(function() {
            (new $.ScrollToFixed(this, options));
        });
    };
})(jQuery);
/*!
	Semantic Select
	Copyright	Paul Wisniowski
	License		MIT
	Version		2.0.0

	http://psdhtml.me
*/
!function(e){"use strict";e.fn.semanticSelect=function(){var t=e(document.getElementsByTagName("body")),s=e(document.documentElement);e(this).each(function(){e(this).attr("aria-hidden",!0).addClass("hidden").wrap('<div class="semantic-select-wrapper" aria-hidden="true" focusable="false"></div>').before('<div class="semantic-select"><span class="input"><div class="text"><span class="value">'+e(this).children().first().html()+'</span></div><span class="ticker"></span></span><ul class="select-'+e(this).attr("id")+'"></ul></div>').find("option").each(function(t){e(this).attr("data-no",t+1);var s=e(this),a=s.clone(),i=e('<span class="inner">'+e(this).html()+"</span>");a.appendTo(s.closest(".semantic-select-wrapper").find("ul")).wrap('<li data-value="'+s.attr("value")+'" data-no="'+s.attr("data-no")+'"><a href="./">'+s.text()+"</a></li>"),s.is("[disabled]")&&a.closest("li").addClass("hidden").find("a").attr({"aria-hidden":!0,focusable:!1}),s.is("[selected]")&&(s.closest(".semantic-select-wrapper").find(".semantic-select").addClass("selected").find(".value").html(s.html()),a.closest("li").addClass("active")),s.is("[data-class]")&&a.closest("li").addClass(s.attr("data-class")),s.is("[value]")&&a.attr("data-value",s.attr("value")),i.parent().parent().data("o",s),s.is("[disabled]")||s.on("click",function(){i.parent().trigger("click")}),e.each(s.data(),function(e){i.parent().attr("data-"+e,s.attr("data-"+e))}),a.remove()}),e(this).is("[multiple]")?e(this).closest(".semantic-select-wrapper").find(".semantic-select").addClass("multiple"):e(this).find("option[selected]:not([disabled])").length||e(this).prop("selectedIndex",0),e(this).find("option[selected]:not([disabled])").length&&e(this).closest(".semantic-select-wrapper").children(".semantic-select").addClass("chosen"),e(this).is("[disabled]")&&e(this).closest(".semantic-select-wrapper").children(".semantic-select").addClass("disabled")}),t.on("click",".semantic-select .input",function(){return e(this).parent().is(".active")?e(this).parent().removeClass("active"):(e(document.getElementsByClassName("semantic-select")).filter(".active").removeClass("active"),e(this).parent().addClass("active")),!1});var a={onClickAnchor:function(){return e(this).closest(".semantic-select").is(".multiple")||(e(this).closest("ul").find(".active").removeClass("active"),e(this).closest(".semantic-select").removeClass("active").find(".text .value").text(e(this).text()).closest(".semantic-select").addClass("selected chosen").closest(".semantic-select-wrapper").find("select").attr("value",e(this).closest(".semantic-select-wrapper").find("select").children("option").attr("selected",!1).prop("selected",!1).parent().children(":eq("+e(this).parent().index()+")").attr("value")).closest("form").addClass(e(this).parent().attr("data-value")+"-chosen"),e(this).closest(".semantic-select-wrapper").find("select > option:eq("+e(this).parent().index()+")").attr("selected",!0).prop("selected",!0),e(this).closest(".semantic-select").next("select").trigger("change",!0).closest(".semantic-select-wrapper").removeClass("error").find(".text .value").text(e(this).text()),e(this).closest(".semantic-select-wrapper").find(".error").remove()),!1},onHTMLSelect:{focus:function(){e(this).parent().children(".semantic-select").addClass("active")},blur:function(){e(this).parent().children(".semantic-select").removeClass("active")},keyup:function(t){13===t.which?e(document.getElementsByClassName("semantic-select")).filter(".active").removeClass("active"):(t.which>=48&&t.which<=57||t.which>=65&&t.which<=90)&&e(this).children("option:selected").click()},change:function(){e(this).is("[multiple]")||(void 0!==e(this).closest("form").validate&&e(this).closest("form.is-error").validate().form(),e(this).closest(".semantic-select-wrapper").find("li.active").removeClass("active"),e(this).closest(".semantic-select-wrapper").find('ul li[data-no="'+e(this).find(":selected").attr("data-no")+'"]').addClass("active"),e(this).closest(".semantic-select-wrapper").find(".text .value").text(e(this).find(":selected").text()))}}};t.on({click:a.onClickAnchor},".semantic-select ul > li > a").closest(".semantic-select").find("ul").each(function(){e(this).children(".active").length||e(this).children("li:first-child").addClass("active")}),s.on("click touchstart",function(t){e(t.target).is(".input")||e(t.target).closest().is(".input")||e(t.target).is(".semantic-select-wrapper,.semantic-select")||e(document.getElementsByClassName("semantic-select")).filter(".active").removeClass("active")}),e(this).closest(".semantic-select-wrapper").find("select").on({focus:a.onHTMLSelect.focus,blur:a.onHTMLSelect.blur}).keyup(a.onHTMLSelect.keyup).on("change",a.onHTMLSelect.change)},e.fn.semanticSelectReload=function(){e(this).closest(".semantic-select-wrapper").find("ul").find("li").remove();var t=1*e(this).children("[data-no]").last().attr("data-no")+1;e(this).find("option").each(function(){void 0===e(this).attr("data-no")&&e(this).attr("data-no",t++),e(this).clone().appendTo(e(this).closest(".semantic-select-wrapper").find("ul"))}),e(this).closest(".semantic-select-wrapper").find("ul").find("option").each(function(){var t,s=e(this)[0].dataset,a=e("<a />");a.html(e(this).html()),(t=e(this).is("[disabled]:not([selected])")?e('<li class="hidden"></li>'):e(this).is("[selected]:not([disabled])")?e('<li class="active"></li>'):e(this).is("[selected][disabled]")?e('<li class="hidden active"></li>'):e("<li></li>")).attr("data-no",e(this).attr("data-no")),void 0!==e(this).attr("value")&&t.attr("data-value",e(this).val()),e.each(s,function(e,t){a.attr("data-"+e,t)}),t.append(a),e(this).replaceWith(t)})}}(jQuery);
/*!
	semanticNumber
	Copyright	Paul Wisniowski
	License		MIT
	Version		1.0.0

	http://psdhtml.me
*/				
(function($){"use strict";$.fn.semanticNumber=function(){$(this).wrap('<div class="semantic-number"></div>').parent().append('<a href="./" class="btn plu" role="button">+</a><a href="./" class="btn min" role="button">-</a>');return $(this).each(function(){this.co=$(this);this.el=this.co.parent().children('input');this.el.data({'min':+this.el.attr('min')||0,'max':+this.el.attr('max')||99999999999999});this.co.parent().children('a.btn').on('click',function(){var sngn=$(this).parent().children('input'),snmin=+sngn.data('min'),snmax=+sngn.data('max'),snval=+sngn.val();if($(this).is('.min')){if(snval>snmin){snval=snval-1;if(snval===snmin){$(this).parent().find('.btn.min').addClass('disabled')}}$(this).parent().find('.btn.plu').removeClass('disabled')}else{if(snval<snmax){snval=snval+1;if(snval===snmax){$(this).parent().find('.btn.plu').addClass('disabled')}}$(this).parent().find('.btn.min').removeClass('disabled')}sngn.val(snval);return false});if(+this.el.val()==this.el.data('min')){this.el.parent().find('.btn.min').addClass('disabled')}else if(+this.el.val()==this.el.data('max')){this.el.parent().find('.btn.plu').addClass('disabled')}})}})(jQuery);

/*!
	Array Equals
	https://stackoverflow.com/a/14853974/1726625
*/
Array.prototype.equals&&console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."),Array.prototype.equals=function(e){if(!e)return!1;if(this.length!=e.length)return!1;for(var r=0,t=this.length;r<t;r++)if(this[r]instanceof Array&&e[r]instanceof Array){if(!this[r].equals(e[r]))return!1}else if(this[r]!=e[r])return!1;return!0},Object.defineProperty(Array.prototype,"equals",{enumerable:!1});

/**
 * Shopify Theme Currency
 */
var shopifyCurrency=function(){var a="${{amount}}";return{formatMoney:function(e,r){"string"==typeof e&&(e=e.replace(".",""));var t="",o=/\{\{\s*(\w+)\s*\}\}/,n=r||a;function s(a,e,r,t){if(r=r||",",t=t||".",isNaN(a)||null===a)return 0;var o=(a=(a/100).toFixed(e)).split(".");return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+r)+(o[1]?t+o[1]:"")}switch(n.match(o)[1]){case"amount":t=s(e,2);break;case"amount_no_decimals":t=s(e,0);break;case"amount_with_comma_separator":t=s(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":t=s(e,0,".",",");break;case"amount_no_decimals_with_space_separator":t=s(e,0," ");break;case"amount_with_apostrophe_separator":t=s(e,2,"'")}return n.replace(o,t)}}}();

// keep loading
var tag = document.createElement('script');
tag.src = custom_async_url;
document.body.appendChild(tag);